<template>
  <div v-if="errorMessage" class="content alert alert-danger" role="alert">
    <h4 class="alert-heading">An error has occured</h4>
    <p>{{ errorMessage }}</p>
  </div>
  <div
    v-if="!dataReady && !errorMessage"
    class="content w-full d-flex justify-content-center"
  >
    <img src="@/assets/img/spinner.gif" alt="Loading..." />
  </div>
  <div v-if="dataReady" class="content">
    <div class="d-flex flex-row">
      <h1 class="content-title flex-grow-1">All Events</h1>
      <router-link class="btn btn-secondary" to="/events/new">
        <i class="fas fa-plus"></i>
        <span class="ml-5">New Event</span>
      </router-link>
    </div>
    <p v-if="activeEvents.length == 0" class="content">
      You don't appear to be a member of any events so far. Either create your
      own in the "My Events" menu or wait to be invited.
    </p>
  </div>
  <div
    class="card p-10 m-10"
    v-for="event in activeEvents"
    :key="event.id"
    :data-id="event.id"
  >
    <div
      class="d-flex flex-column flex-md-row flex-fill align-items-left w-full"
    >
      <div
        class="d-flex flex-row flex-grow-1"
        style="cursor: pointer"
        @click="$router.push({ name: 'Event', params: { eventId: event.id } })"
      >
        <div
          class="w-100 h-100 object-cover object-center flex-shrink-0 align-self-start"
        >
          <img
            class="w-100 h-100"
            style="object-fit: cover"
            :src="this.getImgUrl(event.type)"
            :alt="event.type"
          />
        </div>
        <div class="content my-0 flex-grow-1">
          <h2 class="font-size-16 font-weight-semi-bold my-5">
            {{ event.name }}
          </h2>
          <p class="text-muted my-5">{{ event.description }}</p>
          <span
            class="badge-group my-5"
            role="group"
            aria-label="Badge group example"
          >
            <span class="badge badge-success badge-pill font-size-10 px-10"
              >{{ event.memberCount }} <i class="fas fa-user-friends ml-0"></i
            ></span>
            <span class="badge badge-secondary badge-pill font-size-10 px-10"
              >{{ event.giftCount }} <i class="fas fa-gift ml-0"></i></span
          ></span>
        </div>
      </div>
      <div
        class="content my-0 mx-0 d-flex flex-row flex-no-wrap align-self-end align-self-md-end align-items-end"
      >
        <div class="dropdown">
          <button
            class="btn ml-5"
            data-toggle="dropdown"
            type="button"
            id="dropdown-toggle-btn-1"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-angle-down ml-5" aria-hidden="true"></i>
            <!-- ml-5 = margin-left: 0.5rem (5px) -->
          </button>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdown-toggle-btn-1"
          >
            <router-link
              class="ml-5 dropdown-item"
              :to="{ name: 'Event', params: { eventId: event.id } }"
              ><i class="fas fa-search"></i>
              <span class="ml-5">View</span></router-link
            >
            <a v-if="canShare" @click="share(event)" class="ml-5 dropdown-item"
              ><i class="fas fa-share-alt"></i>
              <span class="ml-5">Share</span></a
            >
            <router-link
              v-if="userId == event.owner.id"
              class="ml-5 dropdown-item"
              :to="{ name: 'EditEvent', params: { eventId: event.id } }"
              ><i class="fas fa-edit"></i
              ><span class="ml-5">Edit</span></router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../../lib/firebase.js";

export default {
  name: "Events",
  components: {},
  data() {
    return {
      events: [],
      dataReady: false,
      errorMessage: null,
      eventsUnsub: null,
    };
  },
  computed: {
    activeEvents: function() {
      return this.events.filter((event) => {
        return event.deleted != true;
      });
    },
    userId: function() {
      return this.$store.getters.getUser.uid;
    },
    canShare: function() {
      return navigator.share;
    },
  },
  methods: {
    async getEvents() {
      try {
        const eventsRef = db.collection("events");
        this.eventsUnsub = await eventsRef
          .where("members", "array-contains", this.userId)
          .orderBy("date")
          .orderBy("name")
          .onSnapshot((querySnapshot) => {
            this.dataReady = true;
            querySnapshot.docChanges().forEach((change) => {
              if (change.type === "added") {
                this.events.splice(change.newIndex, 0, {
                  ...change.doc.data(),
                  ...{ id: change.doc.id },
                });
              }
              if (change.type === "modified") {
                this.events.splice(change.oldIndex, 1);
                this.events.splice(change.newIndex, 0, {
                  ...change.doc.data(),
                  ...{ id: change.doc.id },
                });
              } else if (change.type === "removed") {
                this.events.splice(change.oldIndex, 1);
              }
            });
          });
      } catch (error) {
        console.log(error);
        this.errorMessage = error.message;
      }
    },
    share(event) {
      if (navigator.share) {
        navigator
          .share({
            title: "New GiftSift event",
            text:
              "I've created the '" +
              event.name +
              "' event on GiftSift and want to share it with you.",
            url: document.location.href + "join/" + event.id,
          })
          .then(() => {
            window.analytics.track("Event shared", {
              event: event,
            });
          })
          .catch((error) => console.log("Error sharing", error));
      }
    },
    getImgUrl(pic) {
      return require("../../assets/img/" + pic + ".jpg");
    },
  },
  async mounted() {
    await this.getEvents();
  },
  async beforeUnmount() {
    this.eventsUnsub();
  },
};
</script>
